import { SetStateAction, useEffect, useState } from "react";
import SelectAllCheckBox from "../SelectAllCheckBox";
import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { ICounterpartyReportFilters } from "./CounterpartyReportIndex";
import { returnKeysToMapGeneric } from "../analyticsHelperFunctions";

const CurrencyAndStructureFilters = ({
  data,
  dataFilters,
  setDataFilters,
}: {
  data: IBaseAnalyticsCombined[];
  setData: any;
  dataFilters: ICounterpartyReportFilters;
  setDataFilters: React.Dispatch<SetStateAction<ICounterpartyReportFilters>>;
}) => {
  const keys = [
    "structureType",
    "currency",
  ] as (keyof IBaseAnalyticsCombined)[];

  const [keysToMap, setKeysToMap] = useState(
    returnKeysToMapGeneric(data, keys),
  );

  useEffect(() => {
    setKeysToMap(returnKeysToMapGeneric(data, keys));
  }, [data]);

  useEffect(() => {
    if (dataFilters && keysToMap) {
      setDataFilters({
        ...dataFilters,
        selectedCurrencies: keysToMap.currencyKeys,
        selectedStructure: keysToMap.structureTypeKeys,
      });
    }
  }, []);

  const handleCheckboxChange = (filterValue: string) => {
    const currentState = dataFilters.selectedCurrencies;

    let newData = [];
    if (currentState.includes(filterValue)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== filterValue);
    } else {
      // Add if not selected
      newData = [...currentState, filterValue];
    }
    setDataFilters({ ...dataFilters, selectedCurrencies: newData });
  };

  const handleCheckboxChangeStructure = (structure: string) => {
    const currentState = dataFilters.selectedStructure;

    let newData = [];
    if (currentState.includes(structure)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== structure);
    } else {
      // Add if not selected
      newData = [...currentState, structure];
    }

    setDataFilters({ ...dataFilters, selectedStructure: newData });
  };

  return (
    <>
      {keysToMap ? (
        <div className="flex h-full w-full justify-between overflow-hidden">
          <div className="flex h-full w-full flex-col pl-2">
            <div>Currency:</div>
            <div className="flex h-fit flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"selectedCurrencies"}
                keysToMap={keysToMap}
                keysToMapField={"currencyKeys"}
              />
              {keysToMap.currencyKeys.map((currency, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.selectedCurrencies
                        ? dataFilters.selectedCurrencies.includes(currency)
                        : false
                    }
                    onChange={() => handleCheckboxChange(currency)}
                  />
                  <span className="pl-1">{currency}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex h-full w-full flex-col pl-2">
            <div>Structure Type:</div>

            <div className="flex h-full flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"selectedStructure"}
                keysToMap={keysToMap}
                keysToMapField={"structureTypeKeys"}
              />
              {keysToMap.structureTypeKeys.map((structure, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.selectedStructure
                        ? dataFilters.selectedStructure.includes(structure)
                        : false
                    }
                    onChange={() => handleCheckboxChangeStructure(structure)}
                  />
                  <span className="pl-1">{structure}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default CurrencyAndStructureFilters;
